import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import { ReactComponent as ArrowRight } from '../../../icons/arrow-right-2.svg';
import { ILinkCard } from '../../../interfaces/umbracoNodes/contentSlices';
import { A } from '../../base/typography';

const CardContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 24px;
	width: 100%;
	font-family: ${theme.fonts.Arimo};
	border-radius: 10px;

	${media.desktopSmall`
        padding: 24px 32px;
    `};
`;

const TextWrapper = styled.div`
	width: 100%;
`;

const Title = styled.h3`
	font-size: 22px;
	line-height: 1.5;
	font-weight: ${theme.fonts.weight.medium};
	color: ${theme.colorsV2.mainRed};
	overflow-wrap: break-word;
`;

const Description = styled.p`
	margin: 4px 0 0;
	padding: 0;
	color: ${theme.colorsV2.mainDark};
	font-size: 16px;
	line-height: 1.3;
`;

const IconWrapper = styled.div`
	margin-left: 14px;
	display: flex;

	svg {
		width: 24px;
		height: 24px;

		path {
			stroke: ${theme.colorsV2.mainRed};
			stroke-width: 1.5px;
			transition: stroke 0.3s ease-in-out;

			${media.desktopSmall`
				stroke: ${theme.colors.white};
			`};
		}
	}
`;

const ClickOverlay = styled(A)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	cursor: pointer;
	color: ${theme.colorsV2.grey4};
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	transition: all 0.3s ease-in-out;

	${media.desktopSmall`
		border: 1px solid ${theme.colorsV2.grey4};
		box-shadow: none;

		&:hover {
			color: ${theme.colorsV2.grey4};
			border: none;
			box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);

			& ~ ${IconWrapper} path {
				stroke: ${theme.colorsV2.mainRed};
			}
		}
	`};
`;

interface Props {
	content: ILinkCard;
	className?: string;
}

const LinkCard: FC<Props> = ({ content, className }) => {
	return (
		<CardContainer className={className}>
			<ClickOverlay to={content.Values.Link.Url} target={content.Values.Link.Target} rel="noreferrer" />
			<TextWrapper>
				<Title>{content.Values.Title}</Title>
				<Description>{content.Values.Description}</Description>
			</TextWrapper>
			<IconWrapper>
				<ArrowRight />
			</IconWrapper>
		</CardContainer>
	);
};

export default LinkCard;
